(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["m2u-quick-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('m2u-quick-filters')) {
  customElements.define('m2u-quick-filters', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      const form = this.querySelector('[data-m2u-filter-form]');
      if (!form) return;
      const owned = new Set(Array.from(this.querySelectorAll('[data-m2u-owned]'), element => element.dataset.m2uOwned));
      const transient = name => name === 'page' || /^page_/.test(name) || name === 'section_id' || name === 'sections';
      const currentSort = new URL(window.location.href).searchParams.get('sort_by');
      const sort = form.querySelector('[data-m2u-sort]');
      if (currentSort && Array.from(sort.options).some(option => option.value === currentSort)) sort.value = currentSort;
      this.querySelectorAll('details').forEach(detail => {
        const count = detail.querySelector('[data-m2u-selected]');
        if (!count) return;
        detail.addEventListener('change', () => {
          const selected = detail.querySelectorAll('input:checked').length;
          count.hidden = selected === 0;
          count.textContent = count.dataset.template.replace('__COUNT__', selected);
        }, { signal });
      });
      const validatePrices = () => {
        let valid = true;
        this.querySelectorAll('[data-m2u-price-range]').forEach(range => {
          const minimum = range.querySelector('[data-m2u-price="min"]');
          const maximum = range.querySelector('[data-m2u-price="max"]');
          const reversed = minimum.value !== '' && maximum.value !== '' && minimum.valueAsNumber > maximum.valueAsNumber;
          maximum.setCustomValidity(reversed ? range.dataset.error : '');
          if (reversed) valid = false;
        });
        return valid;
      };
      this.querySelectorAll('[data-m2u-price]').forEach(input => input.addEventListener('input', validatePrices, { signal }));
      form.addEventListener('invalid', event => {
        const detail = event.target.closest('details');
        if (detail) detail.open = true;
      }, { signal, capture: true });
      const stock = this.querySelector('[data-m2u-stock]');
      if (stock) {
        const nativeOptions = Array.from(this.querySelectorAll('[data-m2u-native-availability] input'));
        const inStock = nativeOptions.find(input => input.value === '1');
        const outOfStock = nativeOptions.find(input => input.value === '0');
        stock.checked = Boolean(inStock?.checked && !outOfStock?.checked);
        stock.addEventListener('change', () => {
          nativeOptions.forEach(input => { input.checked = stock.checked && input.value === '1'; });
        }, { signal });
        this.querySelector('[data-m2u-stock-control]').hidden = false;
      }
      form.addEventListener('submit', event => {
        event.stopPropagation();
        if (!validatePrices()) {
          event.preventDefault();
          this.querySelectorAll('[data-m2u-price-range]').forEach(range => { range.closest('details').open = true; });
          form.reportValidity();
          return;
        }
        form.querySelectorAll('[data-m2u-preserved]').forEach(input => input.remove());
        const formNames = new Set(Array.from(form.elements, input => input.name).filter(Boolean));
        new URL(window.location.href).searchParams.forEach((value, name) => {
          if (owned.has(name) || formNames.has(name) || transient(name)) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          input.dataset.m2uPreserved = '';
          form.append(input);
        });
      }, { signal });
      form.addEventListener('formdata', event => {
        this.querySelectorAll('[data-m2u-price]').forEach(input => {
          if (input.value === '') event.formData.delete(input.name);
        });
      }, { signal });
      const clear = this.querySelector('[data-m2u-clear]');
      if (clear) {
        const target = new URL(clear.href, window.location.href);
        const current = new URL(window.location.href);
        target.search = '';
        current.searchParams.forEach((value, name) => {
          if (!name.startsWith('filter.') && !transient(name)) target.searchParams.append(name, value);
        });
        if (!target.searchParams.has('sort_by')) target.searchParams.set('sort_by', form.elements.namedItem('sort_by').value);
        clear.href = target.href;
      }
      this.querySelectorAll('[data-m2u-remove]').forEach(link => {
        const target = new URL(link.href, window.location.href);
        Array.from(target.searchParams.keys()).filter(transient).forEach(name => target.searchParams.delete(name));
        new URL(window.location.href).searchParams.forEach((value, name) => {
          if (!name.startsWith('filter.') && !transient(name) && !target.searchParams.has(name)) target.searchParams.append(name, value);
        });
        link.href = target.href;
      });
      this.classList.add('is-enhanced');
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
